import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { getServiceErrorMessage } from "../helpers"
import { Context, Transitions } from "../types"

export const replaceLessonTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    src: "replaceSectionItem",
    onDone: {
      target: "#StudyPlan.edit_plan.go_back_to_previous",
      actions: assign((_ctx, evt: DoneInvokeEvent<any>) => {
        let message = "Lesson has been replaced"
        if (
          evt.data?.sectionAvailableItems?.every(
            item => item.type === "PRACTICE_TEST"
          )
        ) {
          message = "Practice test has been replaced"
        }

        return {
          studyPlan: evt.data.plan,
          lessonOptions: evt.data.sectionAvailableItems ?? [],
          snackbar: {
            message,
            withUndo: true
          }
        }
      })
    },
    onError: {
      target: "#StudyPlan.edit_plan.go_back_to_previous",
      actions: assign<Context, DoneInvokeEvent<any>>({
        snackbar: (_ctx, _evt) => ({
          message: getServiceErrorMessage("replaceSectionItem", {
            messageData: ["replace lesson"]
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
